import {
	isConsentCategoryAllowed,
	normalizeVisitorIntelligenceTrackingConfig,
} from "@multi-tenant-cms/seo-runtime";
import type {
	CookieConsentCategorySelection,
	CookieConsentConfig,
	VisitorIntelligenceTrackingConfig,
} from "@multi-tenant-cms/types";

export const VISITOR_INTELLIGENCE_BOOTSTRAP_EVENT =
	"cms:visitor-intelligence:bootstrap";

export type TenantVisitorIntelligenceConfig = VisitorIntelligenceTrackingConfig;

function asObject(value: unknown): Record<string, unknown> {
	return typeof value === "object" && value !== null && !Array.isArray(value)
		? (value as Record<string, unknown>)
		: {};
}

function asBoolean(value: unknown, fallback: boolean): boolean {
	return typeof value === "boolean" ? value : fallback;
}

export function normalizeVisitorIntelligenceConfig(
	raw: unknown
): TenantVisitorIntelligenceConfig {
	const object = asObject(raw);
	return normalizeVisitorIntelligenceTrackingConfig({
		...object,
		enabled: asBoolean(object.enabled, false),
	});
}

export function isVisitorIntelligenceBootstrapAllowed(
	config: TenantVisitorIntelligenceConfig,
	consentConfig: CookieConsentConfig,
	selection: CookieConsentCategorySelection
): boolean {
	if (!config.enabled) {
		return false;
	}

	if (!config.require_cookie_consent) {
		return true;
	}

	return isConsentCategoryAllowed(
		consentConfig,
		selection,
		config.consent_category
	);
}
